export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getFirstOfType = (type, components = []) => {
  let target = null;
  for (let i = 0; i < components.length; i++) {
    if (components[i].type === type) return components[i];
    else if (!target) target = getFirstOfType(type, components[i].children);
  };
  return target;
};

export const getById = (id, components = [], iteration = 0) => {
  let target = null;
  for (let i = 0; i < components.length; i++) {
    if (components[i].id === id) return components[i];
    else if (!target) target = getById(id, components[i].children, iteration + 1);
  };
  return target;
};

export const deepClone = (item) => {
  if (item instanceof Array) return item.map(i => deepClone(i));
  else if (typeof item === 'object') {
    return Object.entries(item).reduce((newObj, [key, value]) => ({
      ...newObj,
      [key]: deepClone(value)
    }), {})
  }
  else return item;
};

export const formatPhoneNumber = (phoneNumber) => phoneNumber.length === 10 ? `${'+1'}${phoneNumber}` : `${'+'}${phoneNumber}`;

export const validatePhone = (phoneNumber) => /^\d{10}$/.test(phoneNumber.trim()) || /^\d{11}$/.test(phoneNumber.trim());
export const validateSsn = (ssn) => /^\d{4}$/.test(ssn.trim());
export const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

export const fieldsAreFilled = (formFields) => Object.values(formFields)
  .reduce((isFilled, field) => {
    field.error = field.required && !field.value;
    return !field.error && isFilled
  }, true);

export const makeQueryParams = (keyPairs) => Object.entries(keyPairs)
  .reduce((queryParams, [key, value]) => `${queryParams}&${key}=${value}`, '?');